import { render, staticRenderFns } from "./StudentOverviewTableDialog.vue?vue&type=template&id=22832af5&scoped=true&"
import script from "@/views/Users/Teacher/StudentOverviewTableDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Teacher/StudentOverviewTableDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Teacher/student-overview-table-dialog.scss?vue&type=style&index=0&id=22832af5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22832af5",
  null
  
)

export default component.exports